import { displayDateTimeToMinute, Entity, FieldType, makeClone, PersistenceType } from 'gossamer-unified';
import { Event } from './Event';
import { EventCoHost } from './EventCoHost';

export interface EventHostViewRow {
  event_id: number;
  user_id: string;
  title: string;
  type: string;
  visibility_limit: string;
  start_at: string;
  end_at: string;
  host_type: string;
}

const clone = makeClone();

export const EventHostView: Entity<EventHostViewRow> = {
  id: 'EventHostView',
  title: 'Event',
  service: 'main',
  rowLabel: (row: EventHostViewRow) => `${row.title} (${displayDateTimeToMinute(row.start_at)})`,
  primaryKeyFields: ['event_id', 'user_id'],
  source: {
    tableName: 'public.event_host_view',
  },
  security: EventCoHost.security,
  defaultSort: [['start_at', 'DESC']],
  defaultFilters: Event.defaultFilters,
  listRowLink: (key: string) => {
    const [event_id, _user_id] = key.split('|');
    return `/admin/event/display/${event_id}`;
  },
  fields: {
    event_id: clone(EventCoHost.fields.event_id),
    user_id: clone(EventCoHost.fields.user_id),
    title: clone(Event.fields.title),
    type: clone(Event.fields.type),
    visibility_limit: clone(Event.fields.visibility_limit),
    start_at: clone(Event.fields.start_at),
    end_at: clone(Event.fields.end_at),
    host_type: {
      seq: 20,
      type: FieldType.Options,
      label: 'Host Type',
      options: [
        { id: 'main', label: 'Main Host' },
        { id: 'co', label: 'Co-Host' },
      ],
      listColumn: true,
    },
  },
};
